import useGoToNavigation from "../../../../../util/useGotoNavigation";
import React from "react";
import {PcsDetailType} from "../../detail/interface";
import {UseFormRegister} from "react-hook-form";
import {useUser} from "../../../../../util/userContext/UserContext";

interface PropsType {
    watchCreateDetail: PcsDetailType
    register: UseFormRegister<PcsDetailType>
    btnSave: () => void
    menuTitleText: string
    urlText: string
    isOrderRequest: boolean | undefined
}

export default function Upper({
                                  watchCreateDetail,
                                  register,
                                  btnSave,
                                  menuTitleText,
                                  urlText,
                                  isOrderRequest
                              }: PropsType) {
    const {goToNavigation} = useGoToNavigation();
    const {user} = useUser();

    const goToList = () => {
        goToNavigation(`${urlText}/list`, {}, false)
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">{menuTitleText}{!isOrderRequest ? "신청" : "생성"}</h3>
            <div className="filter_toolbar">
                <button className="btn btn-outline-primary w-100px h-38px" onClick={goToList}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록
                </button>
                <button className="btn btn-primary w-100px h-38px" onClick={btnSave}>
                    신청
                </button>
            </div>
        </div>
        <h5 className="subheading">{menuTitleText}정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>{menuTitleText}번호</th>
                    <td style={{width: "33.34%"}}></td>
                    <th style={{width: "16.66%"}}>상태</th>
                    <td>접수</td>
                </tr>
                <tr>
                    <th>{menuTitleText}일자 <span className="required">*</span></th>
                    <td className="p-4px">
                        <input type="date"
                               className="form-control"
                               max="9999-12-31"
                               value={watchCreateDetail.purchaseOrderDt}
                               {...register("purchaseOrderDt")}
                               disabled={!isOrderRequest}/>
                    </td>
                    <th>주문자</th>
                    <td>{user?.userName}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
}